// Temp signup settings
export const keyStoreRefCode = "settings.refCode";
export const keyStoreTmpSignupFrom = "settings.tmpSignupForm";

// Account config
export const keyStoreAccountConfig = "settings.accountConfig";

export const keyStoreMerchantName = "settings.merchantName";
export const keyStoreIsOnchainAvailable = "settings.isOnchainAvailable";
export const keyStoreCurrency = "settings.currency";
export const keyStoreIsAtm = "settings.isAtm";

// Local settings
export const keyStoreUserType = "settings.userType";
export const keyStoreDeviceName = "settings.deviceName";
export const keyStoreHmac = "settings.hmac";
export const keyStoreIsGuest = "settings.isGuest";
export const keyStoreTransactionsHistory = "data.transactionsHistory";
export const keyStoreTicketsAutoPrint = "settings.ticketsAutoPrint";

// Local wallet config
export const keyStoreZpub = "settings.wallet.zPub";
export const keyStoreMnemonicWords = "settings.wallet.mnemonicWords";
export const keyStoreWalletType = "settings.wallet.type";
export const keyStoreWalletPath = "settings.wallet.path";

// Hardware wallet data
export const keyStoreLedgerBluetoothId = "settings.hw.ledgerBluetoothId";
